// extracted by mini-css-extract-plugin
export default {"active":"styles_active__2tkyf","reset_button":"styles_reset_button__igBGG","label":"styles_label__xmSNL","mg20":"styles_mg20__Km2DH","input":"styles_input__LFSzE"};